
import React, { useState, useEffect } from 'react'
import './index.less'

export default function SelectB(props) {
  const [ifon, setIfon] = useState({
    id: props.id,
    isOpen: false
  })

  let title = null

  const s = props.options.filter((item) => {
    return item.id === ifon.id
  })

  const s1 = props.children.filter((item) => {
    return item.props.id === ifon.id
  })

  if (s.length && s1.length) {
    if (s1[0].props.render) {
      title = s1[0].props.render(s[0])
    } else if (s1[0].props.tag) {
      title = s1[0].props.tag
    } else {
      title = s1[0].props.children
    }
  }

  useEffect(() => {
    const func = () => {
      setIfon({
        ...ifon,
        isOpen: false
      })
    }

    window.addEventListener('click', func)

    return () => {
      window.removeEventListener('click', func)
    }
  })

  if ((props.options.length !== props.children.length) || !props.options) {
    return null
  } else {
    return (<div className='SelectB'>
      <div className='SelectB_title' onClick={(e) => {
        setIfon({
          ...ifon,
          isOpen: !ifon.isOpen
        })
        e.stopPropagation()
      }}>{
          title
        }</div>
      <div className={`SelectB_options ${ifon.isOpen ? 'open' : ''}`}>
        {props.children.map((item, index) => {
          return React.cloneElement(item, {
            item: props.options[index],
            isActive: item.props.id === ifon.id,
            change(id, item) {
              setIfon({
                ...ifon,
                id,
                isOpen: false
              })
              props.onChange && props.onChange(id, item)
            }
          })
        })}
      </div>
    </div>)
  }
}
